import { CHAT_PROVIDER_INSTANCE } from '@sxm-core/utility-code/angular/configuration-token-chat-provider-instance';
import { ChatProviderSierra } from './chats/sierra/ChatProviderSierra';
import { ChatProvider247 } from './chats/247/ChatProvider247';
import { ChatProviderLivePerson } from '@de-care/shared/configuration-tokens-chat';

export function provideChat({
    chatProvider,
}: {
    chatProvider: 'sierra' | '247' | 'liveperson';
}) {
    return [
        {
            provide: CHAT_PROVIDER_INSTANCE,
            useFactory: () => {
                return () => {
                    switch (chatProvider) {
                        case '247': {
                            return new ChatProvider247();
                        }
                        case 'liveperson': {
                            return new ChatProviderLivePerson();
                        }
                        case 'sierra':
                        default: {
                            return new ChatProviderSierra();
                        }
                    }
                };
            },
        },
    ];
}
